import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { encrypt } from "../utils/crypto";

const EmployeeQuickLinks = ({ employee_id, basicDetails }) => {
  const encryptedEmployeeId = encrypt(employee_id);
  const navigate = useNavigate();

  const getEmployeeName = () => {
    return (
      (basicDetails?.first_name ?? "") +
      " " +
      (basicDetails?.middle_name ? basicDetails?.middle_name + " " : "") +
      (basicDetails?.last_name ?? "")
    ).trim();
  };

  const navigationItems = [
    {
      icon: "fa-calendar-days",
      title: "Attendance",
      path: `../attendance-employee/${encryptedEmployeeId}`,
    },
    {
      icon: "fa-address-card",
      title: "Leave dashboard",
      path: `../leave-dashboard/${encryptedEmployeeId}`,
    },
    {
      icon: "fa-umbrella-beach",
      title: "Leaves",
      path: `../leaves-employee/${encryptedEmployeeId}`,
    },
    {
      icon: "fa-sack-dollar",
      title: "Reimbursement",
      path: `../reimbursement/${encryptedEmployeeId}`,
    },
    // {
    //   icon: "fa-list-check",
    //   title: "Task box",
    //   path: `../taskbox/${encryptedEmployeeId}`,
    // },
    {
      icon: "fa-wallet",
      title: "Salary",
      path: `../mypay/${encryptedEmployeeId}`,
    },
    {
      icon: "fa-laptop-file",
      title: "Assigned Assets",
      path: `../assigned-asset/${encryptedEmployeeId}`,
    },
    {
      icon: "fa-folder-open",
      title: "Documents",
      path: `../my-document/${encryptedEmployeeId}`,
      iconPrefix: "fa-regular",
    },
    {
      icon: "fa-location-dot",
      title: "Location",
      path: `../employee-locations?employee_id=${encryptedEmployeeId}`,
    },
    {
      icon: "fa-briefcase",
      title: "Work Status",
      path: `../employee-work-status?employee_id=${encryptedEmployeeId}`,
    },
  ];

  return (
    <div className="text-center">
      <Row>
        {navigationItems.map((item, index) => (
          <Col key={index} xs={4} sm={3} md={2} lg={1} className="mb-3 ms-3">
            <div
              className="d-flex flex-column align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate(item.path, {
                  state: { employeeName: getEmployeeName() },
                })
              }
            >
              <i
                className={`${item.iconPrefix || "fa-solid"} ${item.icon} fa-2x text-primary`}
                title={item.title}
                style={{ 
                  cursor: "pointer"
                }}
              ></i>
              <small className="mt-1 text-muted">{item.title}</small>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default EmployeeQuickLinks;
